import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'inverse';
  size?: 'md' | 'lg';
  className?: string;
  href?: string;
};
export function CtaButton({
  children,
  variant = 'primary',
  size = 'lg',
  className = '',
  href = '#comprar'
}: CtaButtonProps) {
  const base = 'inline-flex w-full items-center justify-center whitespace-nowrap rounded-full font-display font-bold uppercase tracking-wide transition-[background-color,transform,box-shadow] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-forest-800 active:translate-y-px';
  const variants = {
    primary: 'bg-forest-800 text-cream-50 shadow-[0_10px_24px_-14px_rgba(14,31,22,0.9)] hover:bg-forest-950',
    inverse: 'bg-cream-50 text-forest-900 hover:bg-cream-200'
  };
  const sizes = {
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base sm:text-lg'
  };
  return <a href={href} className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-46" data-mp="15bayk1i12a2p">
      {children}
    </a>;
}